import React from "react";
import {
  FooterContainer,
  Copyright
} from "./FooterElements";

function Footer() {
  return (
    <FooterContainer>
      <Copyright>
        <p>&copy; 2026 Hasnat Aleem. All rights reserved.</p>
      </Copyright>
    </FooterContainer>
  );
}

export default Footer;
